import React from 'react';
import pluralize from 'pluralize';

// material ui
import CheckIcon from '@material-ui/icons/CheckCircle';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import { BaseWidget, styles } from './widgets/baseWidget';

const notificationStyles = {
  base: {
    marginRight: '10px',
    height: '14px',
    width: '14px'
  },
  green: { color: '#009E73' }
};

const DevicesDetails = (props) => {
  const header = () => {
    if (!props.totalDevices) {
      return null;
    } else {
      let notificationSymbol = (<CheckIcon style={Object.assign({}, notificationStyles.base, notificationStyles.green)} />);
      let activityNotificationText = 'All devices are mapped';

      if (props.unMappedDevices) {
        notificationSymbol = (<ReportProblemIcon style={notificationStyles.base} className={'warning'} />);
        activityNotificationText = `${props.unMappedDevices} ${pluralize('device', props.unMappedDevices)} are not mapped`;
      }

      return (
        <div style={styles.rowStyle}>
          {notificationSymbol}
          <div style={styles.columnStyle}>
            <div className="hint">{activityNotificationText}</div>
          </div>
        </div>
      );
    }
  };

  const main = () => {
    return {
      header: `Total ${pluralize('device', props.totalDevices)}`,
      counter: props.totalDevices      
    };
  }

  return (
    <div>
      <h4 className="dashboard-header">
        <span>Devices</span>
      </h4>
      <div style={Object.assign({ marginBottom: '30px', marginTop: '50px' }, props.styles)}>
        <BaseWidget header={header()} main={main()} onClick={() => props.clickHandle({ route: 'system-admin/device-management'})}/>
      </div>
    </div>
  );
};

export default React.memo(DevicesDetails);
